var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (current, featured, heading, partner, past, seeAll, upcoming) {
jade_mixins["showsGallery"] = jade_interp = function(shows, isFeatured, type){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"partner-shows-container grid-3-up\">");
jade_mixins["showFigureContent"] = jade_interp = function(show, isFeatured){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var posterImageUrl = show.posterImageUrl(isFeatured) || ""
buf.push("<div" + (jade.attr("style", "background-image: url(" + (posterImageUrl) + ")", true, true)) + " class=\"partner-show-cover-image\"><img" + (jade.attr("src", "" + (posterImageUrl) + "", true, true)) + (jade.attr("alt", show.formatFeedItemHeading(), true, true)) + "><div class=\"partner-show-overlay\"></div></div><figurecaption class=\"partner-show-caption\"><h5 class=\"avant-garde-header-center partner-show-heading\">" + (jade.escape(null == (jade_interp = show.formatLeadHeading()) ? "" : jade_interp)) + "</h5>");
if ( show.has('artists'))
{
buf.push("<h3 class=\"partner-show-artists\">" + (jade.escape(null == (jade_interp = show.formatArtists()) ? "" : jade_interp)) + "</h3>");
}
buf.push("<h4 class=\"partner-show-name\">" + (jade.escape(null == (jade_interp = show.formatFeedItemHeading()) ? "" : jade_interp)) + "</h4><h6 class=\"partner-show-time\">" + (jade.escape(null == (jade_interp = show.runningDates()) ? "" : jade_interp)) + "</h6></figurecaption>");
};
var slicedShows = shows.slice(0,30)
// iterate slicedShows
;(function(){
  var $$obj = slicedShows;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var show = $$obj[$index];

buf.push("<figure" + (jade.attr("data-show-id", show.get('id'), true, true)) + " class=\"partner-show grid-item\">");
if ( show.get('displayable'))
{
buf.push("<a" + (jade.attr("href", show.href(), true, true)) + ">");
jade_mixins["showFigureContent"](show, isFeatured);
buf.push("</a>");
}
else
{
jade_mixins["showFigureContent"](show, isFeatured);
}
buf.push("</figure>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var show = $$obj[$index];

buf.push("<figure" + (jade.attr("data-show-id", show.get('id'), true, true)) + " class=\"partner-show grid-item\">");
if ( show.get('displayable'))
{
buf.push("<a" + (jade.attr("href", show.href(), true, true)) + ">");
jade_mixins["showFigureContent"](show, isFeatured);
buf.push("</a>");
}
else
{
jade_mixins["showFigureContent"](show, isFeatured);
}
buf.push("</figure>");
    }

  }
}).call(this);

if ( shows.length > 30)
{
buf.push("<a" + (jade.attr("data-show-type-id", type, true, true)) + " class=\"avant-garde-button-white is-block js-partner-shows-more\">Show More</a><div class=\"loading-spinner\"></div>");
}
buf.push("</div>");
};
buf.push("<div class=\"partner-shows\">");
if ( heading)
{
buf.push("<h2 class=\"avant-garde-header-center partner-shows-heading\">" + (jade.escape(null == (jade_interp = heading) ? "" : jade_interp)) + "</h2>");
}
if ( featured)
{
buf.push("<section class=\"partner-shows-section featured\">");
jade_mixins["showsGallery"]([featured], true, 'featured');
buf.push("</section>");
}
if ( current && current.length > 0)
{
buf.push("<section class=\"partner-shows-section current\"><h2 class=\"avant-garde-header-center partner-shows-section-heading\">Current Shows</h2>");
jade_mixins["showsGallery"](current, false, 'current');
buf.push("</section>");
}
if ( upcoming && upcoming.length > 0)
{
buf.push("<section class=\"partner-shows-section upcoming\"><h2 class=\"avant-garde-header-center partner-shows-section-heading\">Upcoming Shows</h2>");
jade_mixins["showsGallery"](upcoming, false, 'upcoming');
buf.push("</section>");
}
if ( past && past.length > 0)
{
buf.push("<section class=\"partner-shows-section past\"><h2 class=\"avant-garde-header-center partner-shows-section-heading\">Past Shows</h2>");
jade_mixins["showsGallery"](past, false, 'past');
buf.push("</section>");
}
if ( seeAll)
{
buf.push("<section class=\"partner-shows-section\"><div class=\"partner-shows-see-all avant-garde-header-center\"><a" + (jade.attr("href", "" + (partner.href()) + "/shows", true, true)) + " class=\"faux-underline-hover partner-route-link\">See all shows</a></div></section>");
}
buf.push("</div>");}.call(this,"current" in locals_for_with?locals_for_with.current:typeof current!=="undefined"?current:undefined,"featured" in locals_for_with?locals_for_with.featured:typeof featured!=="undefined"?featured:undefined,"heading" in locals_for_with?locals_for_with.heading:typeof heading!=="undefined"?heading:undefined,"partner" in locals_for_with?locals_for_with.partner:typeof partner!=="undefined"?partner:undefined,"past" in locals_for_with?locals_for_with.past:typeof past!=="undefined"?past:undefined,"seeAll" in locals_for_with?locals_for_with.seeAll:typeof seeAll!=="undefined"?seeAll:undefined,"upcoming" in locals_for_with?locals_for_with.upcoming:typeof upcoming!=="undefined"?upcoming:undefined));;return buf.join("");
};
module.exports = template;